import { Cubby } from "../Cubby";

export const managePublicKeyValidationData = (cubby: Cubby, data: any) => {
  console.log("in managePublicKeyValidationData", data);
  if (data.publicKey !== cubby.lastProposedPublicKeyForKeysend) {
    console.log("public key did not match last proposed public key, ignoring");
    return;
  }

  if (data.errorMessage) {
    cubby.lastKeysendErrormessage = data.errorMessage;
    cubby.lastProposedPublicKeyForKeysendIsValid = false;
    return;
  }

  cubby.lastProposedPublicKeyForKeysendIsValid = true;
};

export const handleKeysendPublicKeyChange = (
  cubby: Cubby,
  newValue: string
) => {
  cubby.lastProposedPublicKeyForKeysend = newValue;
  cubby.lastKeysendErrormessage = "";
  cubby.lastProposedPublicKeyForKeysendIsValid = false;

  if (newValue.length !== 66) {
    cubby.lastKeysendErrormessage = "Public key must be 66 characters long";
    return;
  }

  cubby.cubbyFastInfo("validate_public_key_for_keysend", {
    publicKey: newValue,
  });
};
